module.exports = __webpack_public_path__ + "static/media/msg-edit-normal.2f836805.png";